import { connect } from 'react-redux';
import AgencyDashboard from './AgencyDashboard';
import {
  getSpecificAgencyData,
  getAgenciesTree,
  setAgenciesTree,
  refreshUser,
  getSelectedAgenciesAgentsAndAppointmentCount
} from 'state/actions/actions';
import withLocalLoader from 'components/HOCs/withLocalLoader';

function mapStateToProps({ agencyManagement }) {
  return {
    agencyData: agencyManagement.agencyData,
    agenciesTree: agencyManagement.agenciesTree,
    agencyDashboardAgents: agencyManagement.agencyDashboardAgents
  };
}

export default connect(mapStateToProps, {
  refreshUser,
  getSpecificAgencyData,
  getAgenciesTree,
  setAgenciesTree,
  getSelectedAgenciesAgentsAndAppointmentCount
})(
  withLocalLoader(
    AgencyDashboard,
    true,
    'Agency Management',
    'Agency Management',
    false /* useLocalLoader: overlay handled inside AgencyDashboard */
  )
);
